import { useFragment } from 'react-relay';
import { graphql } from 'react-relay';

import { type useHasPurchasedFromSeller_seller$key } from './__generated__/useHasPurchasedFromSeller_seller.graphql';

const sellerFragment = graphql`
    fragment useHasPurchasedFromSeller_seller on Seller {
        buyerOrderReview(userId: $userId) @include(if: $isYouvePurchasedCalloutVariant) {
            __typename
        }
    }
`;

export const useHasPurchasedFromSeller = ({
    seller: sellerRef,
    hasUser,
}: {
    seller: useHasPurchasedFromSeller_seller$key | null | undefined;
    hasUser: boolean;
}): boolean => {
    const seller = useFragment(sellerFragment, sellerRef);
    return hasUser && !!seller?.buyerOrderReview;
};
